// Inline script injected into <head> via gatsby-ssr.js onRenderBody.
// Must run before any tag (GTM/GA4) so Google Consent Mode defaults are
// in place before those tags read them. Kept as a plain string (no imports)
// because it executes as a raw <script> tag, not as a bundled module.
const CONSENT_STORAGE_KEY = 'sphere_consent';

const consentInlineScript = `
(function () {
  var STORAGE_KEY = '${CONSENT_STORAGE_KEY}';
  var saved = null;
  try { saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY)); } catch (e) {}

  var gpc = navigator.globalPrivacyControl === true;

  var c = {
    analytics: saved ? !!saved.analytics : true,
    ads: saved ? !!saved.ads : true,
    optout: saved ? !!saved.optout : false
  };
  if (gpc) {
    c.ads = false;
    c.optout = true;
  }

  window.CGR_CONSENT = c;
  window.CGR_CONSENT_GPC = gpc;

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag;
  gtag('consent', 'default', {
    analytics_storage: c.analytics ? 'granted' : 'denied',
    ad_storage: c.ads ? 'granted' : 'denied',
    ad_user_data: c.ads ? 'granted' : 'denied',
    ad_personalization: c.ads ? 'granted' : 'denied'
  });

  // Tag firewall. Tags injected by the GTM container are blocked here, before
  // they load: session recorders are never allowed, and the ad stack loads
  // only while advertising consent is granted. GTM injects tags via
  // createElement + appendChild/insertBefore, and this script runs first.
  // ClickGuard is no longer used: blocked outright, even if a stale GTM tag remains.
  // Contentsquare is Hotjar's parent and records sessions too.
  var ALWAYS_BLOCKED = /(^|\\.)hotjar\\.(com|io)|hotjar-|clarity\\.ms|clickguard\\.com|contentsquare\\.(net|com)/i;
  var ADS_GATED = /bat\\.bing\\.com|tctm\\.|connect\\.facebook\\.net|oaiq\\.|bzrcdn\\.openai\\.com/i;
  // Security, never consent-gated: ClickCease bot/click-fraud protection.
  // Its loader rotates domains (ob.brilliantlocco.com, ob.calderovian.com, ...),
  // so it is matched by the loader shape ob.<domain>/i/<hash>.js, not by host.
  var ALWAYS_ALLOWED = /clickcease\\.com|^https?:\\/\\/ob\\.[a-z0-9-]+(\\.[a-z0-9-]+)*\\/i\\/[\\w-]+\\.js(\\?|$)/i;

  function isBlockedScript(node) {
    try {
      if (!node || !node.tagName || node.tagName !== 'SCRIPT') return false;
      var src = node.src || '';
      if (!src) return false;
      if (ALWAYS_ALLOWED.test(src)) return false;
      if (ALWAYS_BLOCKED.test(src)) return true;
      if (!(window.CGR_CONSENT && window.CGR_CONSENT.ads) && ADS_GATED.test(src)) return true;
      return false;
    } catch (e) { return false; }
  }

  function guard(method) {
    var original = Node.prototype[method];
    Node.prototype[method] = function (node) {
      if (isBlockedScript(node)) { return node; }
      return original.apply(this, arguments);
    };
  }
  guard('appendChild');
  guard('insertBefore');
})();
`;

module.exports = { consentInlineScript, CONSENT_STORAGE_KEY };
